import { render, staticRenderFns } from "./Loanable.vue?vue&type=template&id=7b52c39c&"
import script from "./Loanable.vue?vue&type=script&lang=js&"
export * from "./Loanable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports